import React from 'react';
import './Loader.css';

const Loader = () => (
    <div className="overlay">
        <i className="fa fa-spin fa-circle-o-notch"/>
    </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js